import { forwardRef } from 'react';
import PropTypes from 'prop-types';

import UserProfileLogo from '../UserProfileLogo';

import './MemberInfoCard.css';

const MemberInfoCard = forwardRef(({ imageId, name, lines, className, style, ...rest }, ref) => (
    <div ref={ref} className={`memberInfoCard ${className || ''}`} style={style} {...rest}>
        <UserProfileLogo image_id={imageId || false} width="50px" height="50px" className="memberInfoCardImage" />
        <div className="memberInfoCardText">
            <span className="memberInfoCardName">{name}</span>
            {lines?.map((line, index) => (
                <span className="memberInfoCardSubInfo" key={index}>{line}</span>
            ))}
        </div>
    </div>
));

MemberInfoCard.displayName = 'MemberInfoCard';

MemberInfoCard.propTypes = {
    imageId: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
    name: PropTypes.node,
    lines: PropTypes.arrayOf(PropTypes.node),
    className: PropTypes.string,
    style: PropTypes.object,
};

export default MemberInfoCard;
